import {Component, OnInit} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NotificationService } from '../../../../Services/notification.service';
import {DataService} from '../../../../Services/data.service';
import { AppConfigService } from '../../../../Services/app-config.service';
import { Router } from '@angular/router';
import { DateFilterService } from '../../../../Services/dateFilter.service';
import { ResponseModel } from '../../../../DataModels/response-model';
import { NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import { PagerStateService } from '../../../../Services/pager-state.service';
import { NgbpaginationConfigService } from '../../../../Services/ngbpagination-config.service';
import {ListPageBase} from '../../../list-page-base';

@Component({
  selector: 'app-reporting-field-list',
  templateUrl: './reporting-field-list.component.html',
  styleUrls: ['./reporting-field-list.component.css'],
  standalone: false
})
export class ReportingFieldListComponent extends ListPageBase implements OnInit {
  constructor(
    private titleService: Title,
    private tableDataService: DataService,
    private notification: NotificationService,
    private dateFilter: DateFilterService,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
  }

  isLoaded = false;
  vm: any = {
    list: [],
    rfType: '',
    title: 'Reporting Field',
    Preferences: [],
    permissions: [],
    listInitiated: false,
    formRoute: '/admin/reporting-field-form',
  };



  ngOnInit() {
    this.restorePagerState();
    this.titleService.setTitle($localize`:Reporting Field List@@reportingFieldTypeList:Reporting Field List`);
    this.vm.list = [];
    this.getData();
  }

  getData() {
    let paramString =
      '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString +=
      '&fromDate=' +
      (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString +=
      '&toDate=' +
      (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.tableDataService
      .getApiListData('reporting_field', paramString)
      .subscribe((result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);

        this.isLoaded = true;
        this.vm.listInitiated = true;
      });
    this.tableDataService
      .getApiListData('reporting_field_type?state=active')
      .subscribe((result2: ResponseModel) => {
        this.vm.rfType = result2.Data;
      });
  }

  onNavigate(aID: string) {
    this.router.navigate([this.vm.formRoute, { id: aID }]).then();
  }

  // ----------------- Server side paging --------------------

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  getPagedApiData() {
    let paramString =
      '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString +=
      '&fromDate=' +
      (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString +=
      '&toDate=' +
      (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.tableDataService
      .getApiListData('reporting_field', paramString)
      .subscribe((result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);

        this.isLoaded = true;
        this.vm.listInitiated = true;
      });
    this.tableDataService
      .getApiListData('reporting_field_type?state=active')
      .subscribe((result2: ResponseModel) => {
        this.vm.rfType = result2.Data;
      });
  }

  serverSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  clearServerSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }
}
